import React, { Component } from 'react'
import $ from 'jquery'
import { shape, string, func } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions as cmsActions } from 'services/cms-state'
import Header from 'components/header'
import Footer from 'components/footer'
import MainContent from 'components/main-content'
import SecondaryNav from 'components/secondary-nav'
import MetaTags from './MetaTags'

window.jQuery = $
window.$ = $

export class CMS extends Component {
  componentDidMount() {
    this.getCMSData()
  }

  componentDidUpdate(prevProps) {
    const { location: newLocation } = this.props
    const { location } = prevProps
    if (location.pathname !== newLocation.pathname) {
      this.getCMSData()
    }
  }

  render() {
    const metaData = this.props.pageContent.metaContent
    return (
      <div className={this.props.className}>
        {metaData ? <MetaTags {...this.props} pageContent={metaData.configs} /> : null}
        <Header {...this.props} />
        <SecondaryNav {...this.props} />
        <MainContent {...this.props} />
        <Footer {...this.props} />
      </div>
    )
  }

  getCMSData() {
    const { cmsActions } = this.props
    cmsActions.loadCms()
  }
}

CMS.propTypes = {
  className: string.isRequired,
  cmsComponents: shape({}).isRequired,
  pageContent: shape({}).isRequired,
  location: shape({}),
  cmsActions: shape({
    loadCms: func,
  }),
}

CMS.defaultProps = {
  location: '',
  cmsActions: {
    loadCms: x => x,
  },
}

const mapStateToProps = ({ ui, cmsData }) => ({
  pageContent: cmsData,
  ui,
})

const mapDispatchToProps = dispatch => ({
  cmsActions: bindActionCreators(cmsActions, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(CMS)



// WEBPACK FOOTER //
// ./components/cms/index.js